import {API} from "@/Composables/api";

const restoreGroupConversation = async (group: string, params = {}) => {
    return API.post(route("groups.conversations.restore", group), params);
};

export {restoreGroupConversation};
